<template>
  <!-- 实验巡课 -->
  <div class="con_contain">
    <div class="mainpage">
      <div class="head">
        <div class="searchcontain">
          <input class="elinput" placeholder="请输入实验用房" type="text" v-model="queryParams.keyword" />
          <div class="searchbt" @click="searchbt">搜索</div>
        </div>
      </div>
      <div class="titlecategory">
        <div class="titlecategory-item">
          <div class="item-left">学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;院</div>
          <div class="item-right">
            <div
              :class="queryParams.college_id === ''
              ? 'item-right-text item-right-text-heightlight'
              : 'item-right-text'
              "
              @click.stop="academybtclick('')"
            >全部</div>
            <div
              :class="queryParams.college_id === item.id
              ? 'item-right-text item-right-text-heightlight'
              : 'item-right-text'
              "
              @click.stop="academybtclick(item.id)"
              v-for="(item, index) in collegelist"
              :key="index"
            >{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="image-contain">
        <div class="image-item">
          <template v-if="tableData.length">
            <el-row :gutter="20">
              <el-col v-for="(item, i) in tableData" :key="i" :span="6" class="el-col-item">
                <div class="contant-box">
                  <BaseVideo
                    :vData="{cameraId: `${'video_' + item.id}`, hlsurl: item.url}"
                    :videoWidth="'100%'"
                    :videoHeight="'400px'"
                    class="isVideo"
                  ></BaseVideo>
                  <!-- <video
                    :id="'video_' + item.id"
                    class="video-js vjs-default-skin vjs-big-play-centered isVideo videoTourItem"
                    :key="i"
                    controls
                    muted
                    preload="auto"
                  >
                    <source :src="item.url" type="application/x-mpegURL" />
                  </video>-->
                  <div class="video-infos">
                    <h3>{{ item.lab_room_name }}</h3>
                    <p>{{ item.lab_centre_name }}</p>
                    <p>{{ item.lab_name }}</p>
                  </div>
                </div>
              </el-col>
            </el-row>
          </template>
        </div>
        <div class="elpagination">
          <div class="elpagination-title">共{{ total }}条</div>
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="12"
            :current-page="queryParams.page"
            @current-change="pageChange"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import videojs from "video.js"
import "videojs-contrib-hls"
import BaseVideo from "../modules/baseVideo.vue"
import { getcollegelist } from "@/api/common"
import { getVideoTourList, getPatrolVideo } from "@/api/videos"
export default {
  name: "mainpage",
  components: {
    BaseVideo,
  },
  data () {
    return {
      tableData: [],
      total: 0,
      queryParams: {
        keyword: "",
        college_id: "",
        page: 1,
        per_page: 12,
      },
      tableLoad: false,
      player: {},
      videoTimer: null,
    }
  },
  computed: {},
  created () {
    this.getList()
    this.getcollegelist({ record_type: 1 }) //record_type 是否获取全部记录 0：分页，1：全部
  },
  mounted () {
    // const that = this
    // that.videoTimer = setInterval(() => {
    //   if (that.tableData.length) {
    //     that.initPatrolVideo()
    //   }
    // }, 2 * 60 * 1000)
  },
  beforeDestroy () {
    // let that = this
    // if (that.videoTimer) {
    //   clearInterval(that.videoTimer)
    // }
    // if (Object.keys(that.player).length) {
    //   for (let key in that.player) {
    //     that.player[key].dispose()
    //   }
    // }
  },
  methods: {
    getcollegelist (params) {
      this.collegelist = []
      const condition = sessionStorage.getItem('college_all')
      if (condition) {
        this.collegelist = JSON.parse(condition)
      } else {
        getcollegelist(params).then((response) => {
          if (response.data && response.data.length > 0) {
            response.data.forEach((item) => {
              this.collegelist.push({
                id: item.id,
                name: item.name,
              })
            })
          }
        }).catch((error) => { })
      }
    },
    // 获取列表数据
    getList () {
      this.tableLoad = true
      getVideoTourList(this.queryParams)
        .then((res) => {
          this.tableLoad = false
          if (res.code === 0 && res.data) {
            this.tableData = res.data.data
            this.total = res.data.total
            if (res.data?.data && res.data.data.length) {
              this.initPatrolVideo()
            } else {
              // if (Object.keys(this.player).length) {
              //   for (let key in this.player) {
              //     this.player[key].dispose()
              //   }
              // }
            }
          }
        })
        .catch(() => { })
    },
    //页码发生改变时
    pageChange (val) {
      this.queryParams.page = val
      this.getList()
    },
    searchbt () {
      this.queryParams.page = 1
      this.getList()
    },
    academybtclick (id) {
      this.queryParams.page = 1 // 搜索默认查询第一页
      this.queryParams.college_id = id
      this.getList()
    },
    initVideo () {
      let that = this
      that.player = {}
      that.tableData.map((item, i) => {
        that.player[item.id] = videojs(
          "video_" + item.id,
          {
            bigPlayButton: false,
            textTrackDisplay: false,
            posterImage: true,
            errorDisplay: false,
            controlBar: true,
            muted: true,
            restoreEl: true,
          },
        )
        that.player[item.id].src({ src: item.url, type: "application/x-mpegURL", })
        that.player[item.id].play()
      })
    },
    initPatrolVideo () {
      let that = this
      let ids = ""
      that.tableData.forEach((item, index) => {
        if (!index) {
          ids = item.id
        } else {
          ids = ids + "," + item.id
        }
      })
      getPatrolVideo({ id: ids }).then(res => {
        if (res.code === 0) {
          if (res?.data && res?.data?.length) {
            that.tableData.map(item => {
              res.data.forEach(ele => {
                if (item.id === ele.id) item.url = ele.url
              })
              return item
            })
          }
          // that.initVideo()
        }
      }).catch(() => { })
    },
  },
};
</script>
<style scoped lang="scss">
@media screen and (max-width: 640px) {
  .con_contain {
    display: flex;
    justify-content: center;
    align-items: center;

    .mainpage {
      background: #ffffff;
      width: 100%;

      .head {
        margin-top: 84px;
        display: flex;
        justify-content: center;
        align-items: center;

        .head-title {
          font-size: 20px;
          font-weight: 400;
          color: #288add;
          user-select: none;
          white-space: nowrap;
        }

        .searchcontain {
          position: relative;

          .elinput {
            width: 260px;
            height: 28px;
            border-radius: 25px;
            padding-left: 20px;
            border: 1px solid #3d84ff;

            &:focus {
              outline: none;
            }
          }

          .searchbt {
            position: absolute;
            top: 0px;
            right: 0px;
            margin-left: 17px;
            width: 85px;
            height: 32px;
            background: #3d84ff;
            border-radius: 25px;
            font-size: 15px;
            font-weight: 400;
            color: #ffffff;
            text-align: center;
            line-height: 32px;
            cursor: pointer;
            user-select: none;

            &:active {
              background: #26b7ffa9;
            }
          }
        }
      }

      .titlecategory {
        margin-top: 30px;
        background: #fbfbfb;
        border-radius: 4px;
        // padding: 30px 10px 10px 30px;

        .titlecategory-item {
          // display: flex;
          // justify-content: flex-start;
          // align-items: flex-start;

          .item-left {
            flex-basis: 80px;
            font-size: 16px;

            font-weight: bold;
            color: #333;
            user-select: none;
            white-space: nowrap;
            height: 35px;
            line-height: 35px;
            margin-left: 10px;
          }

          .item-right {
            flex-grow: 1;
            flex-shrink: 1;
            margin-left: 10px;
            line-height: 25px;

            .item-right-text {
              display: inline-block;
              margin-bottom: 4px;
              margin-right: 25px;
              font-size: 14px;

              font-weight: 400;
              color: #666;
              user-select: none;
              white-space: nowrap;
              cursor: pointer;
            }

            .item-right-text-heightlight {
              color: #3d84ff;
              height: 24px;
              line-height: 24px;
              background: rgba(61, 132, 255, 0.1);
              border-radius: 12px;
              text-align: center;
              padding: 0 15px;
            }
          }
        }
      }

      .image-contain {
        .image-item {
          margin-bottom: 50px;
          height: 100%;
          width: 100%;
          overflow: hidden;
          z-index: 9;
          position: relative;
        }

        .elpagination {
          margin-bottom: 40px;
          display: flex;
          justify-content: center;
          align-items: center;

          .elpagination-title {
            margin-right: 4px;
          }
        }

        .openroom_img {
          position: relative;
          z-index: 9999;
          background: #3d84ff;
          width: 100%;
          height: 160px;
          font-size: 24px;
          color: #fff;

          span {
            display: block;
            word-break: break-all;
            text-align: center;
            line-height: 160px;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .con_contain {
    display: flex;
    justify-content: center;
    align-items: center;

    .mainpage {
      background: #ffffff;
      width: 100%;

      .head {
        margin-top: 80px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-right: 20px;

        .head-title {
          font-size: 20px;
          font-weight: 400;
          color: #288add;
          user-select: none;
          white-space: nowrap;
        }

        .searchcontain {
          position: relative;

          .elinput {
            width: 260px;
            height: 28px;
            border-radius: 25px;
            padding-left: 20px;
            border: 1px solid #3d84ff;

            &:focus {
              outline: none;
            }
          }

          .searchbt {
            position: absolute;
            top: 0px;
            right: 0px;
            margin-left: 17px;
            width: 85px;
            height: 32px;
            background: #3d84ff;
            border-radius: 25px;
            font-size: 15px;
            font-weight: 400;
            color: #ffffff;
            text-align: center;
            line-height: 32px;
            cursor: pointer;
            user-select: none;

            &:active {
              background: #26b7ffa9;
            }
          }
        }
      }

      .titlecategory {
        margin-top: 20px;
        background: #fbfbfb;
        border-radius: 4px;
        // padding: 30px 10px 10px 30px;

        .titlecategory-item {
          // display: flex;
          // justify-content: flex-start;
          // align-items: flex-start;

          .item-left {
            flex-basis: 80px;
            font-size: 16px;

            font-weight: bold;
            color: #333;
            user-select: none;
            white-space: nowrap;
            height: 35px;
            line-height: 35px;
            margin-left: 10px;
          }

          .item-right {
            flex-grow: 1;
            flex-shrink: 1;
            margin-left: 10px;
            line-height: 25px;

            .item-right-text {
              display: inline-block;
              margin-bottom: 4px;
              margin-right: 25px;
              font-size: 14px;

              font-weight: 400;
              color: #666;
              user-select: none;
              white-space: nowrap;
              cursor: pointer;
            }

            .item-right-text-heightlight {
              color: #3d84ff;
              height: 24px;
              line-height: 24px;
              background: rgba(61, 132, 255, 0.1);
              border-radius: 12px;
              text-align: center;
              padding: 0 15px;
            }
          }
        }
      }

      .image-contain {
        .image-item {
          margin-bottom: 50px;
          height: 100%;
          width: 100%;
          overflow: hidden;
          z-index: 9;
          position: relative;
        }

        .elpagination {
          margin-bottom: 40px;
          display: flex;
          justify-content: center;
          align-items: center;

          .elpagination-title {
            margin-right: 4px;
          }
        }

        .openroom_img {
          position: relative;
          z-index: 9999;
          background: #3d84ff;
          width: 100%;
          height: 160px;
          font-size: 24px;
          color: #fff;

          span {
            display: block;
            word-break: break-all;
            text-align: center;
            line-height: 160px;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {
  .con_contain {
    display: flex;
    justify-content: center;
    align-items: center;

    .mainpage {
      background: #ffffff;
      width: 1760px;

      .head {
        margin-top: 30px;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .head-title {
          font-size: 20px;
          font-weight: 400;
          color: #288add;
          user-select: none;
          white-space: nowrap;
        }

        .searchcontain {
          position: relative;

          .elinput {
            width: 260px;
            height: 28px;
            border-radius: 25px;
            padding-left: 20px;
            border: 1px solid #3d84ff;

            &:focus {
              outline: none;
            }
          }

          .searchbt {
            position: absolute;
            top: 0px;
            right: 0px;
            margin-left: 17px;
            width: 85px;
            height: 32px;
            background: #3d84ff;
            border-radius: 25px;
            font-size: 15px;
            font-weight: 400;
            color: #ffffff;
            text-align: center;
            line-height: 32px;
            cursor: pointer;
            user-select: none;

            &:active {
              background: #26b7ffa9;
            }
          }
        }
      }

      .titlecategory {
        margin-top: 20px;
        background: #fbfbfb;
        border-radius: 4px;
        padding: 30px 10px 30px 30px;

        .titlecategory-item {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;

          .item-left {
            flex-basis: 80px;
            font-size: 16px;

            font-weight: bold;
            color: #333;
            user-select: none;
            white-space: nowrap;
          }

          .item-right {
            flex-grow: 1;
            flex-shrink: 1;
            margin-left: 15px;

            .item-right-text {
              display: inline-block;
              margin-bottom: 4px;
              margin-right: 30px;
              font-size: 14px;

              font-weight: 400;
              color: #666;
              user-select: none;
              white-space: nowrap;
              cursor: pointer;
            }

            .item-right-text-heightlight {
              color: #3d84ff;
              height: 24px;
              line-height: 24px;
              background: rgba(61, 132, 255, 0.1);
              border-radius: 12px;
              text-align: center;
              padding: 0 15px;
            }
          }
        }
      }

      .image-contain {
        .image-item {
          margin-bottom: 50px;
          height: 100%;
          width: 100%;
          overflow: hidden;
        }

        .elpagination {
          margin-bottom: 40px;
          display: flex;
          justify-content: center;
          align-items: center;

          .elpagination-title {
            margin-right: 4px;
          }
        }

        .openroom_img {
          position: relative;
          z-index: 9999;
          background: #3d84ff;
          width: 100%;
          height: 160px;
          font-size: 24px;
          color: #fff;

          span {
            display: block;
            word-break: break-all;
            text-align: center;
            line-height: 160px;
          }
        }
      }
    }
  }
}
.el-col-item {
  margin-top: 20px;
}
.contant-box {
  border: 1px solid #e8e8e8;
  // .isVideo {
  //   width: 100%;
  //   height: 350px;
  //   video {
  //     object-fit: contain;
  //   }
  // }
}

.video-infos {
  padding: 0 20px;
  h3 {
    font-size: 18px;
    margin-top: 10px;
  }
  p {
    font-size: 16px;
    margin-top: 10px;
    color: #999999;
    &:last-child {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }
  }
}
</style>
